import * as React from 'react';
import './MessageModal.css';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { ACTION_TYPE, GeneralMessageActionsButton } from '../GeneralMessageActionsButton/GeneralMessageActionsButton';

interface Props {
  children?: React.ReactNode;
  isOpen: boolean;
  title: string;
  closeButtonText: string;
  submitButtonText: string;
  onCloseClick: () => void;
  onNextClick: () => void;
  onPreviousClick: () => void;
  onSaveClick: () => void;
  onSendClick: () => void;
  onScheduleClick: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  isNextButtonDisabled?: boolean;
  onActiveActionChange?: (actionType: ACTION_TYPE) => void;
  isError: boolean;
  fullScreen?: boolean;
}

export const GeneralMessageModal: FunctionComponent<Props> = props => {
  if (!props.isOpen) {
    return null;
  }

  const modalClasses = classNames({
    mDisplayBlock: props.isOpen,
    show: props.isOpen,
    modal: true,
    fade: true
  });

  const {
    title,
    onCloseClick,
    onNextClick,
    closeButtonText,
    submitButtonText,
    hasNext,
    isNextButtonDisabled,
    isError,
    fullScreen
  } = props;

  const renderButtons = () => {
    if (hasNext) {
      return (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onNextClick}
          disabled={isNextButtonDisabled || isError}
        >
          {submitButtonText}
        </button>
      );
    } else {
      return null;
    }
  };

  const renderPreviousStepButton = () => {
    if (props.hasPrevious) {
      return (
        <button type="button" className="btn btn-secondary" disabled={isError} onClick={props.onPreviousClick}>
          Previous step
        </button>
      );
    } else {
      return null;
    }
  };

  const dialogClasses = classNames(
    'modal-dialog',
    fullScreen ? 'mGeneralMessageModalFullScreen' : 'mGeneralMessageModalWidth'
  );

  return (
    <div className={modalClasses}>
      <div className={dialogClasses}>
        <div className="modal-content mGeneralMessageModalContent">
          <div className="modal-header d-flex mGeneralMessageModalHeader">
            <div className="mGeneralMessageModalTitleWrap">
              <span className="mGeneralMessageModalEyebrow">General message</span>
              <h5 className="modal-title mGeneralMessageModalTitle">{title}</h5>
            </div>
            <button type="button" className="close" onClick={onCloseClick}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body mGeneralMessageModalBody">{props.children}</div>
          <div className="modal-footer mGeneralMessageModalFooter">
            <button type="button" className="btn btn-secondary" onClick={onCloseClick} disabled={isError}>
              {closeButtonText}
            </button>
            {renderPreviousStepButton()}
            {renderButtons()}
            {!hasNext && (
              <GeneralMessageActionsButton
                onSendClick={props.onSendClick}
                onSaveClick={props.onSaveClick}
                onScheduleClick={props.onScheduleClick}
                onActiveActionChange={props.onActiveActionChange}
                isDisabled={isNextButtonDisabled}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
